import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton
} from '@mui/material';
import {
  ReportOutlined,
  CloseOutlined,
  MessageOutlined,
  PrivacyTipOutlined,
  DescriptionOutlined
} from '@mui/icons-material';

interface PatronMenuProps {
  open: boolean;
  onClose: () => void;
  onReport: () => void;
  onMessageManagement: () => void;
}

const PatronMenu: React.FC<PatronMenuProps> = ({
  open,
  onClose,
  onReport,
  onMessageManagement
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          mx: 2
        }
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 2,
            borderBottom: (theme) => 
              `1px solid ${theme.palette.mode === 'light' ? '#e0e0e0' : '#424242'}`
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Chat Options
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseOutlined />
          </IconButton>
        </Box>

        {/* Menu Items */}
        <Box sx={{ p: 2 }}>
          {/* Report Button */}
          <Button
            fullWidth
            startIcon={<ReportOutlined />}
            onClick={() => {
              onReport();
              onClose();
            }}
            sx={{
              justifyContent: 'flex-start',
              py: 1.5,
              px: 2,
              mb: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500,
              color: 'text.primary',
              '&:hover': {
                backgroundColor: (theme) => 
                  theme.palette.mode === 'light' ? '#f5f5f5' : '#2a2a2a'
              }
            }}
          >
            Report Issue
          </Button>

          {/* Message Management Button */}
          <Button
            fullWidth
            startIcon={<MessageOutlined />}
            onClick={() => {
              onMessageManagement();
              onClose();
            }}
            sx={{
              justifyContent: 'flex-start',
              py: 1.5,
              px: 2,
              mb: 2,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500,
              color: 'primary.main',
              '&:hover': {
                backgroundColor: (theme) => 
                  theme.palette.mode === 'light' ? '#e3f2fd' : '#1a2533'
              }
            }}
          >
            Message Management
          </Button>

          {/* Legal Links Section */}
          <Box sx={{ 
            borderTop: (theme) => 
              `1px solid ${theme.palette.mode === 'light' ? '#e0e0e0' : '#424242'}`, 
            pt: 2 
          }}>
            <Typography 
              variant="caption" 
              sx={{ 
                color: 'text.secondary', 
                fontWeight: 500, 
                mb: 1, 
                display: 'block',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              Legal
            </Typography>
            
            {/* Privacy Policy Link */}
            <Button
              fullWidth
              startIcon={<PrivacyTipOutlined />}
              onClick={() => {
                window.open('https://tablechat.io/privacy', '_blank');
                onClose();
              }}
              sx={{
                justifyContent: 'flex-start',
                py: 1.5,
                px: 2,
                mb: 1,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: 400,
                color: 'text.secondary',
                '&:hover': {
                  backgroundColor: (theme) => 
                    theme.palette.mode === 'light' ? '#f5f5f5' : '#2a2a2a'
                }
              }}
            >
              Privacy Policy
            </Button>

            {/* Terms of Service Link */}
            <Button
              fullWidth
              startIcon={<DescriptionOutlined />}
              onClick={() => {
                window.open('https://tablechat.io/terms', '_blank');
                onClose();
              }}
              sx={{
                justifyContent: 'flex-start',
                py: 1.5,
                px: 2,
                mb: 1,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: 400,
                color: 'text.secondary',
                '&:hover': {
                  backgroundColor: (theme) => 
                    theme.palette.mode === 'light' ? '#f5f5f5' : '#2a2a2a'
                }
              }}
            >
              Terms of Service
            </Button>
          </Box>

        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PatronMenu;
